import { actions as coreActions, selectors as coreSelectors, clientFactory } from 'mage-core'
import * as Sentry from 'mage-deps/@sentry/browser'
import * as R from 'ramda'

/** THUNKS **/
const storeDetails = (client, userId, details) => {
  return client
    .request({
      method: 'PUT',
      url: `/users/${userId}`,
      data: details
    })
}

const saveDetails = (userId, details) => (dispatch, getState) => {
  const state = getState()
  const client = clientFactory(state)('/api/users')

  dispatch(coreActions.profile.updating())

  return storeDetails(client, userId, details)
    .then(() => dispatch(coreActions.profile.update.succeeded()))
    .catch(err => {
      dispatch(coreActions.profile.update.failed())
      Sentry.captureException(err)

      throw err
    })
}

const resetPassword = userId => (dispatch, getState) => {
  const state = getState()
  const client = clientFactory(state)('/api/users')

  dispatch(coreActions.password.resetting())

  return client
    .request({
      method: 'POST',
      url: `/actions/reset_password?user_id=${userId}`
    })
    .then(() => dispatch(coreActions.password.reset.succeeded()))
    .catch(err => {
      dispatch(coreActions.password.reset.failed(R.propOr(err, 'response', err)))
      Sentry.captureException(err)

      throw err
    })
}

const fetchRequester = userId => (dispatch, getState) => {
  if (coreSelectors.isMerchantsRealm(getState())) {
    const client = clientFactory(getState())('/api/users')
    return dispatch(coreActions.requester.fetch(client, userId))
  }
}

const updateRequester = (userId, data) => (dispatch, getState) => {
  if (coreSelectors.isMerchantsRealm(getState())) {
    const client = clientFactory(getState())('/api/users')
    return dispatch(coreActions.requester.update(client, userId, data))
  }
}

export {
  saveDetails,
  resetPassword,
  fetchRequester,
  updateRequester
}
